<p-tabView> 
    <p-tabPanel header="Stock List">

        <p-table #tt [columns]="cols" [value]="stkLst" [paginator]="true" [rows]="50"  >
            <ng-template pTemplate="caption">
                <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText size="50" placeholder="Global Filter" 
                       (input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr> 
                    <th *ngFor="let col of columns">
                        {{col.header}}
                    </th>
                </tr>    
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                    <td *ngFor="let col of columns">
                        
                        <p *ngIf="col.field == 'symbol'; else otherFields " align="center">
                            <p-button  (click)='getProfile(rowData[col.field])' label="{{rowData[col.field]}}"></p-button> 
                        </p>
                        <ng-template #otherFields>
                            <p>{{rowData[col.field]}} </p>
                        </ng-template> 
                    </td>
                </tr>
            </ng-template>

        </p-table>
        
      </p-tabPanel>
</p-tabView>